var Wakelock = require('../../../vendor/wakelock/wakelock');

module.exports = function initWakelock (scene) {
  if (!scene.isMobile) { return; }

  var wakelock = scene.wakelock = new Wakelock();
  scene.addEventListener('enter-vr', function () { wakelock.request(); });
  scene.addEventListener('exit-vr', function () { wakelock.release(); });
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/aframe/src/core/scene/wakelock.js
// module id = 1950
// module chunks = 0